import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { USER_ENDPOINTS } from '../../../config/endpoints'
import type { IResetPasswordClient } from '../data/data-sources/i-reset-password-client'
import type { ResetPasswordRequest } from '../domain/models/reset-password'

export class ResetPasswordService implements IResetPasswordClient {
  constructor(private readonly axios: AxiosInstance) {}

  async reset(params: ResetPasswordRequest): Promise<ApiResponse> {
    try {
      const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
        USER_ENDPOINTS.resetPassword,
        params,
      )

      if (result.data.success === false) {
        return {
          success: result.data.success,
          message: result.data.message,
          status: result.status,
        }
      }

      return {
        success: result.data.success,
        message: result.data.message,
        status: result.status,
        data: result.data.data, // Inclui o token JWT
      }
    } catch (error: any) {
      const axiosError = error as AxiosError<AxiosDataResponse>
      return {
        success: false,
        message: axiosError.response?.data?.message,
        status: axiosError.response?.status!,
      }
    }
  }
}
